"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = require("lodash");

var _Checkable = _interopRequireDefault(require("../../Buttons/Checkable"));

var _LabeledCheckbox = require("./LabeledCheckbox.styles");

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _inputValidator = _interopRequireDefault(require("../../../utils/inputValidator/inputValidator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LabeledCheckbox = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(LabeledCheckbox, _React$PureComponent);

  var _super = _createSuper(LabeledCheckbox);

  function LabeledCheckbox(props) {
    var _this;

    _classCallCheck(this, LabeledCheckbox);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "validateInput", function (event) {
      var _this$props = _this.props,
          displayName = _this$props.displayName,
          originalValue = _this$props.value,
          name = _this$props.name,
          rules = _this$props.validationRules;
      var fieldName = displayName || name;

      if (Object.keys(rules) < 1) {
        return null;
      }

      if (!event) {
        return _this.validateAllRules();
      }

      var type = event.type,
          newValue = event.value; // Since we have multiple forms of validation/masking going on, this juggling is required
      // If you are curious about this, place `console.log(newValue, originalValue, event)` on line 199
      // Then edit the input with validation in the readme, remove all characters
      // you'll see that the empty case is special
      // this is the best i can explain this issue at present - but the following line addresses this potential issue

      var value = (0, _lodash.isNil)(newValue) ? originalValue : newValue;

      if (Object.keys(rules).includes(type)) {
        var ruleset = rules[type];
        return _this.updateErrors({
          value: value,
          name: fieldName,
          rules: ruleset
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "validateAllRules", function () {
      var _this$props2 = _this.props,
          displayName = _this$props2.displayName,
          checked = _this$props2.checked,
          name = _this$props2.name,
          rules = _this$props2.validationRules;
      var fieldName = displayName || name;
      var translatedValue = !!checked;
      var eventKeys = Object.keys(rules);
      var compiledRules = eventKeys.reduce(function (accum, key) {
        var eventRules = rules[key];
        var filteredRules = eventRules.filter(function (rule) {
          return !(0, _lodash.find)(accum, rule) && !accum.includes(rule);
        });
        return [].concat(_toConsumableArray(accum), _toConsumableArray(filteredRules));
      }, []);
      return _this.updateErrors({
        value: translatedValue,
        name: fieldName,
        rules: compiledRules
      });
    });

    _defineProperty(_assertThisInitialized(_this), "updateErrors", function (fieldData) {
      var validatedInput = (0, _inputValidator.default)(_objectSpread(_objectSpread({}, fieldData), {}, {
        errors: []
      }));

      _this.setState({
        errors: validatedInput.errors
      });

      return validatedInput.errors;
    });

    _defineProperty(_assertThisInitialized(_this), "errorMsg", function () {
      var errors = _this.state.errors;
      return (0, _lodash.castArray)(errors).map(function (error) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "c-labeled-checkbox-error-message",
          key: "error-msg-".concat(error)
        }, error);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      return _this.props.onChange && _this.props.onChange(e, _this.props.value);
    });

    _this.state = {
      errors: _toConsumableArray(props.errors)
    };
    return _this;
  }

  _createClass(LabeledCheckbox, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          checked = _this$props3.checked,
          checkedIconName = _this$props3.checkedIconName,
          className = _this$props3.className,
          dataTestId = _this$props3.dataTestId,
          id = _this$props3.id,
          label = _this$props3.label,
          name = _this$props3.name,
          uncheckedIconName = _this$props3.uncheckedIconName,
          rules = _this$props3.validationRules,
          value = _this$props3.value;
      var errors = this.state.errors;
      return /*#__PURE__*/_react.default.createElement(_LabeledCheckbox.StyledLabeledCheckbox, {
        className: className,
        "data-test-id": dataTestId
      }, /*#__PURE__*/_react.default.createElement("label", {
        className: "c-labeled-checkbox-wrapper",
        "data-test-id": "labeled-checkbox-wrapper",
        htmlFor: name,
        onChange: this.handleChange
      }, /*#__PURE__*/_react.default.createElement(_Checkable.default, {
        checked: checked,
        checkedIconName: checkedIconName,
        dataTestId: "labeled-checkbox-checkbox",
        id: id || name,
        name: name,
        readOnly: true,
        type: "checkbox",
        uncheckedIconName: uncheckedIconName,
        value: value || label,
        colorTheme: "primary"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "c-labeled-checkbox-label",
        "data-test-id": "labeled-checkbox-label"
      }, label)), Object.keys(rules).length > 0 && /*#__PURE__*/_react.default.createElement("div", {
        className: "c-labeled-checkbox-error-container",
        "data-test-id": "labeled-checkbox-errors"
      }, errors.length > 0 && this.errorMsg()));
    }
  }]);

  return LabeledCheckbox;
}(_react.default.PureComponent);

_defineProperty(LabeledCheckbox, "propTypes", {
  /** Where the checkbox is checked */
  checked: _propTypes.default.bool,

  /** Icon for Checked State */
  checkedIconName: _propTypes.default.string,

  /** Checkbox class */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** The display name is used when presenting error messages */
  displayName: _propTypes.default.string,

  /** Flag used for indicating an error state for the input */
  errors: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Checkbox id */
  id: _propTypes.default.string,

  /** Checkbox Label */
  label: _propTypes2.default.children,

  /** Checkbox name */
  name: _propTypes.default.string,

  /** Onchange Handler */
  onChange: _propTypes.default.func.isRequired,

  /** Icon for Unchecked State */
  uncheckedIconName: _propTypes.default.string,

  /** Controls when validation is triggered */
  validationRules: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]))),

  /** Checkbox value */
  value: _propTypes.default.string
});

_defineProperty(LabeledCheckbox, "defaultProps", {
  checked: false,
  checkedIconName: undefined,
  className: undefined,
  displayName: undefined,
  errors: [],
  id: undefined,
  label: '',
  name: undefined,
  uncheckedIconName: undefined,
  validationRules: {},
  value: ''
});

var _default = LabeledCheckbox;
exports.default = _default;